<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  export let type = "button";
  export let secondary = false;
  export let negative = false;
  export let disabled = false;
  export let width = "100px";
  export let height = "34px";
  export let title = "";

  function onClick() {
      if (!disabled) dispatch("click");
  }
</script>

<button class:secondary class:negative class:disabled {type} {title} on:click={() => onClick()} style="width: {width}; height: {height}">
  <slot />
</button>

<style>
  button {
      border-color: #5399D0;
      border-radius: var(--border-radius);
      background-color: #5399D0;
      color: white;
      margin: 0;
      padding: 0;
      cursor: pointer;
  }

  button.disabled {
      border-color: #bdbdbd;
      background-color: #bdbdbd;
      color: #888888;
  }

  button:not(.disabled):hover {
      border-color: #4081B8;
      background-color: #4081B8;
  }

  button:not(.disabled):active {
      border-color: #3C6E95;
      background-color: #3C6E95;
  }

  button:not(.disabled):focus {
      border-color: #000;
  }

  .secondary {
      background-color: transparent;
      border-color: transparent;
      color: black;
  }

  .secondary:not(.disabled):hover {
      background-color: transparent;
      border-color: #4081B8;
  }

  .secondary:not(.disabled):active {
      background-color: transparent;
      border-color: #3C6E95;
  }

  .negative {
      border-color: #d05353;
      background-color: #d05353;
      color: white;
  }

  .negative:not(.disabled):hover {
      border-color: #b84040;
      background-color: #b84040;
  }

  .negative:not(.disabled):active {
      border-color: #953c3c;
      background-color: #953c3c;
  }
</style>